import React, { useState } from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import { styled } from "@mui/material/styles";
import { orange } from "@mui/material/colors";

import { Message } from "../../../types/models/Chat";
import { simpleDate, simpleTime } from "../../../utils/dateUtils";
import AppMedialViewer from "../../../components/apps/AppMedialViewer";
import { customerServiceImage } from "../../../constants/image_path";

const ReceiverMessageWrapper = styled("div")(() => {
  return {
    mt: 8,
    display: "flex",
    justifyContent: "flex-start",
    "&:last-of-type": {
      marginBottom: 0,
    },
  };
});

const MessageChat = styled("div")(({ theme, className }) => {
  return {
    display: "inline-flex",
    border: `solid 1px ${theme.palette.grey[200]}`,
    borderTopRightRadius: 16,
    borderBottomRightRadius: 16,
    padding: "10px 16px",
    position: "relative",
    fontSize: 14,
    backgroundColor:
      className === "isImage" ? "white" : theme.palette.background.paper,

    ".last-chat-message &": {
      borderBottomLeftRadius: 16,
    },
  };
});

interface ReceiverMessageItemProps {
  item: Message;
}

const ReceiverMessageItem: React.FC<ReceiverMessageItemProps> = ({ item }) => {
  const [isOpenImage, setOpenImage] = useState(false);
  const onToggleImage = () => setOpenImage(!isOpenImage);

  const renderTime = (date: Date) => {
    if (date) {
      const today = new Date();
      const todayDate = simpleDate(today);
      const msgDate = simpleDate(date);
      if (todayDate === msgDate) {
        return <span>{simpleTime(date)}</span>;
      } else {
        return (
          <span>
            {simpleDate(date)} {simpleTime(date)}
          </span>
        );
      }
    }
  };

  const convertNewlinesToBreaks = (text: string) => {
    return text.split("\n").map((line, index) => (
      <span key={index}>
        {line}
        <br />
      </span>
    ));
  };

  return (
    <ReceiverMessageWrapper>
      <Box sx={{ position: "relative", display: "flex" }}>
        <Avatar
          sx={{
            backgroundColor: orange[500],
            width: 50,
            height: 50,
            mr: 2,
          }}
          className="message-chat-avatar"
          src={customerServiceImage}
        />
        <Box sx={{ position: "relative" }} className="message-chat-item">
          {!item.isGreet && (
            <Box
              component="span"
              sx={{
                fontSize: 12,
                color: (theme) => theme.palette.text.secondary,
                display: "block",
                mb: 0.5,
              }}
              className="message-time"
            >
              {renderTime(item.createdAt)}
            </Box>
          )}

          <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            {item.text.isImage ? (
              <Box
                sx={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "flex-start",
                  "& img": {
                    objectFit: "cover",
                    borderRadius: 1,
                    width: "90%",
                    display: "block",
                    marginRight: 0,
                  },
                }}
              >
                <img
                  alt="text"
                  src={item.text.image.url}
                  onClick={onToggleImage}
                />
              </Box>
            ) : (
              <MessageChat className={`${item.text.isImage && "isImage"}`}>
                <Box component="p">
                  {convertNewlinesToBreaks(item.text.message)}
                </Box>
              </MessageChat>
            )}
          </Box>
        </Box>
      </Box>
      <AppMedialViewer
        media={item?.text?.image?.url}
        onClose={onToggleImage}
        isOpen={isOpenImage}
      />
    </ReceiverMessageWrapper>
  );
};

export default ReceiverMessageItem;
